<template>
  <v-container py-0>
    <v-card color="transparent" flat light>
      <v-card-text class="py-0">
        <v-layout row wrap my-2>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.global.active') }}
          </v-flex>
          <v-flex xs12 md6>
            <button-state :state="!!training.active" />
          </v-flex>
        </v-layout>
        <v-divider />
        <v-layout row wrap my-2>
          <v-flex xs12 md4 class="body-2">
            {{ $t('titles.matches.started') }}
          </v-flex>
          <v-flex xs12 md6>
            <button-state :state="!!training.started" />
          </v-flex>
        </v-layout>
        <v-divider />
        <v-layout row wrap my-2>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.matches.finalized') }}
          </v-flex>
          <v-flex xs12 md6>
            <button-state :state="!!training.ended" />
          </v-flex>
        </v-layout>
        <v-divider />
        <!-- <v-layout row wrap my-2>
          <v-flex xs12 md4 class="body-2">{{
            $t('titles.matches.status')
          }}</v-flex>
          <v-flex xs12 md6>{{ training.status }}</v-flex>
        </v-layout>-->
        <!-- <v-divider></v-divider> -->
        <v-layout row wrap my-2>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.global.date') }}
          </v-flex>
          <v-flex xs12 md6>
            {{ formatDate(training.date) }}
          </v-flex>
        </v-layout>
        <v-divider />
        <v-layout row wrap my-2>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.global.time') }}
          </v-flex>
          <v-flex xs12 md6>
            {{ training.time }}
            <span
              v-if="training.wtz && training.wtz != $store.state.offset"
              style="font-size: 11px"
              >{{ ` (GMT ${training.wtz})` }}</span
            >
          </v-flex>
        </v-layout>

        <v-divider />
        <v-layout row wrap my-2>
          <v-flex xs12 md4 class="body-2">
            {{ $tc('models.team') }}
          </v-flex>
          <v-flex xs12 md6>
            <v-chip v-if="training.teamId" color="white" small>
              <v-avatar size="32" style="padding: 0">
                <img :src="training.teamId.logo" alt />
              </v-avatar>
              <v-list-tile-content>
                <v-list-tile-title class="body-1">
                  {{ training.teamId.name }}
                </v-list-tile-title>
                <v-list-tile-sub-title
                  v-if="training.teamId.categories"
                  class="caption primary--text text--lighten-1 text-truncate"
                >
                  {{ training.teamId.categories.join(', ') }}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-chip>
          </v-flex>
        </v-layout>

        <v-divider />
        <v-layout row wrap my-2>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.global.location') }}
          </v-flex>
          <v-flex xs12 md6>
            <v-chip v-if="training.location" color="white" small>
              <v-avatar size="32">
                <img :src="training.location.photo" alt />
              </v-avatar>
              {{ training.location.name }}
            </v-chip>
            <span v-else>--</span>
          </v-flex>
        </v-layout>

        <v-divider />
        <v-layout row wrap my-2>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.global.createdBy') }}
          </v-flex>
          <v-flex xs12 md6>
            {{ training.createdBy }}
          </v-flex>
        </v-layout>
        <v-divider />
        <v-layout row wrap my-2>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.global.createdAt') }}
          </v-flex>
          <v-flex xs12 md6>
            {{ formatDate(training.createdAt, true) }}
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { formatDate } from '@/helpers/dateHelper'
export default {
  name: 'TabView',
  props: {
    training: {
      type: Object,
      default: () => {},
      required: true,
    },
  },

  methods: {
    formatDate(date, time = false) {
      return formatDate(date, time)
    },
  },
}
</script>
